import { MainButtonStyled } from "./style";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import CloseIcon from "@mui/icons-material/Close";

interface MainButtonProps {
  onClick: () => void;
  isOpen: boolean;
}

export const MainButton = ({ onClick, isOpen }: MainButtonProps) => {
  return (
    <MainButtonStyled onClick={onClick} isOpen={isOpen}>
      {isOpen ? (
        <CloseIcon fontSize="small" />
      ) : (
        <AccessibilityNewIcon fontSize="small" />
      )}
    </MainButtonStyled>
  );
};
